export default __webpack_public_path__ + "static/media/MaddenNFL20.a38e34dd.jpg";